module.exports = __webpack_public_path__ + "assets/img/e9d8d0e4acb8cda30520faf8d183e7c8.svg";